import { createVariants } from '../constants'

export function Label({ htmlFor, label }: { htmlFor: string; label: React.ReactNode }) {
  return (
    <label htmlFor={htmlFor} className={createVariants.label.base}>
      {label}
    </label>
  )
}
